// extracted by mini-css-extract-plugin
export default {"home":"Emails_home__UKBrW","welcome":"Emails_welcome__LWe+Y","buttonBar":"Emails_buttonBar__5oD+9","errorNotification":"Emails_errorNotification__COgbM"};